import type { Equipment, Event } from "../types/dataTypes";
import type { MeetState } from "../types/stateTypes";

export function wrapsOnlyAffectSquatEnabled(
  meet: Pick<MeetState, "federation"> & Partial<Pick<MeetState, "wrapsOnlyAffectSquat">>,
): boolean {
  if (typeof meet.wrapsOnlyAffectSquat === "boolean") return meet.wrapsOnlyAffectSquat;
  return meet.federation.trim().toLowerCase() === "wrpf argentina";
}

export function equipmentForEvent(equipment: Equipment, event: Event, wrapsOnlyAffectSquat: boolean): Equipment {
  if (!wrapsOnlyAffectSquat) return equipment;
  if (equipment === "Bare") return "Sleeves";
  if (equipment === "Wraps" && !event.includes("S")) return "Sleeves";
  return equipment;
}
